import { useAuthContext } from "@/components/AuthProvider";
import { ToBox } from "@/components/Box";
import { getAPIBase } from "@/core/config";
import { RELEASE_IMPERSONATION_URL } from "@/core/urls";
import Masks from "@/images/masks.svg?react";

export default function ReleaseButton({ user }) {
  const { csrfToken } = useAuthContext();

  const handleRelease = () => {
    const formData = new FormData();
    const adminUrl = `${getAPIBase()}/regenerus-admin/accounts/user/`;
    formData.append('next', adminUrl);
    
    fetch(RELEASE_IMPERSONATION_URL, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'X-CSRFToken': csrfToken
      },
      body: formData,
      redirect: 'manual'
    }).then((res) => {
      if (res.type === 'opaqueredirect' || res.ok) {
        window.location.href = adminUrl;
      }
    }).catch((err) => console.error(err));
  };

  return (
    <ToBox
      borderRadius="50%"
      as="button"
      borderWidth="2px"
      borderStyle="solid"
      position="relative"
      display="flex"
      justifyContent="center"
      alignItems="center"
      onClick={handleRelease}
      bg="red"
      borderColor="white"
      size={30}
      ml="10px"
    >
      <Masks
        fill="white"
        width={20}
        title={`You are impersonating user ${user?.email}.\nClick here to release this user.`}
      />
    </ToBox>
  );
}
